// nodeTemporalDisplay.js — friendly date labels for form read-only / visitor Peek

import { formatTemporalFieldValue } from 'views/utils/temporalFieldFormat';

const DATE_OPTIONS = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};

const DATETIME_OPTIONS = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
};

/**
 * Format a schema temporal field value for display (matches list / Library cards).
 *
 * @param {unknown} value
 * @param {'date'|'datetime'|'daterange'|'datetimerange'|'annualdate'} fieldType
 * @returns {string}
 */
export function formatNodeTemporalDisplay(value, fieldType) {
  return formatTemporalFieldValue({
    value,
    fieldType,
    locale: 'en-US',
    dateOptions: DATE_OPTIONS,
    dateTimeOptions: DATETIME_OPTIONS,
  }) || '';
}

export default formatNodeTemporalDisplay;
